import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        background: {
            default: '#F5F6F8',
        },
        primary: {
            dark: 'rgb(48, 48, 48)',
            light: '#3C4252',
            main: '#3C4252',
        },
        secondary: {
            dark: '#3C4252',
            light: '#039be5',
            main: '#039be5',
        },
    },
});

export default theme;
